import { useNavigate } from 'react-router-dom';

import { MIN_ADULTS } from '../../constants/tripSearchParty';
import { TripSearch, useTripSearch } from '../../contexts/TripSearchContext';
import { SearchTab, buildSearchResultsPath } from '../../utils/tripSearchResults';

export interface TripSearchEditor {
  tripSearch: TripSearch;
  setDestination: (destination: string) => void;
  setDates: (checkin: string | null, checkout: string | null) => void;
  setAdults: (adults: number) => void;
  setChildren: (children: number) => void;
  /** Empties the saved picks; the submitted party is left alone. */
  clearAll: () => void;
  /** Records the party as submitted and lands on the tab's results. */
  submit: (typedText: string) => void;
}

/** Live, per-field edits of the saved trip search for a phone search surface. */
export function useTripSearchEditor(tab: SearchTab): TripSearchEditor {
  const navigate = useNavigate();
  const { tripSearch, updateTripSearch, submitTripSearch } = useTripSearch();

  return {
    tripSearch,
    setDestination: (destination) => updateTripSearch({ destination }),
    setDates: (checkin, checkout) => updateTripSearch({ checkin, checkout }),
    setAdults: (adults) => updateTripSearch({ adults }),
    setChildren: (children) => updateTripSearch({ children }),
    clearAll: () => {
      updateTripSearch({
        destination: '',
        checkin: null,
        checkout: null,
        adults: MIN_ADULTS,
        children: 0,
      });
    },
    submit: (typedText) => {
      submitTripSearch({});
      navigate(buildSearchResultsPath(tab, tripSearch, typedText), {
        state: { landOnResults: true },
      });
    },
  };
}
